import React from 'react';
import {MODE_SOLUTION} from '../../../../constants';

const Next = props => {
  const {mode, hasNextQuestion, nextQuestion} = props;
  const next = mode === MODE_SOLUTION && hasNextQuestion;

  return (
    <button className={'btn btn__next ' + (!next ? 'btn--disabled' : '')} onClick={next ? nextQuestion : null}>&#9654;</button>
  );
};

export default Next;
